const numberWithDecimals = (number: number, decimals: number) => {
  return parseFloat(
    (
      Number(Math.round(number * 10 ** decimals).toFixed(decimals)) /
      10 ** decimals
    ).toString()
  );
};

export default numberWithDecimals;
